import { z } from 'zod';
import { id } from '../../common/atomic/id';
import { sex } from '../../common/atomic/sex';
import { date } from '../../common/atomic/date';
import { careRequirementsSchema } from '../../common/basic/careRequirement';
import { addressSchema } from '../../common/basic/address';
import { emergencyContactSchema } from '../../common/basic/emergencyContact';
import dayjs from 'dayjs';

export const createApplicantSchema = z.object({
  serviceId: id.refine(val => val > 0, { message: 'Musí být vybrána služba' }),
  clientId: id.optional(),
  keyEmp: id,
  firstName: z
    .string()
    .min(2, { message: 'Jméno musí být dlouhé aspoň 2 znaky' }),
  lastName: z
    .string()
    .min(2, { message: 'Příjmení musí být dlouhé aspoň 2 znaky' }),
  title: z.string().optional(),
  sex,
  birthdate: date,
  statusDesc: z.string().min(1, { message: 'Popis nesmí být prázdný' }),
  careReq: careRequirementsSchema,
  note: z.string().nullable(),
  prefTime: z.string().nullable(),
  servAddress: addressSchema.optional(),
  permAddress: addressSchema,
  commDate: date,
  startDate: date.optional().nullable(),
  cancelReasons: z.array(z.string()),
  contacts: z.array(emergencyContactSchema),
});

export type CreateApplicant = z.infer<typeof createApplicantSchema>;

export const defaultApplicant: CreateApplicant = {
  serviceId: 0,
  keyEmp: 1,
  firstName: '',
  lastName: '',
  sex: 'O',
  birthdate: '',
  statusDesc: '',
  careReq: [],
  note: null,
  prefTime: null,
  servAddress: {
    street: '',
    city: '',
    postCode: '',
    descNum: 0,
    orientNum: 0,
  },
  permAddress: {
    street: '',
    city: '',
    postCode: '',
    descNum: 0,
    orientNum: 0,
  },
  commDate: dayjs().format('YYYY-MM-DD'),
  startDate: null,
  cancelReasons: [],
  contacts: [
    {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      relation: '',
    },
  ],
};
